export const queryParams = {
  refetchOnMountOrArgChange: true,
};
